<template>
  <section :id="'timeline-section-' + item.title" class="timeline-section" :class="['bg-' + item.background, item.watermark ? '-watermark' : '']" :data-index="pagePosition">
    <Observer :name="pagePosition !== 1 ? 'fade-up' : ''" @enter="enter">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 col-md-6 order-1" :class="item.side === 'left' ? 'order-md-0' : 'order-md-1'">
            <strong class="date font-timeline-year" v-if="item.title"><span>{{ item.title.substr(0, 2) }}</span>{{ item.title.substr(2) }}</strong>
            <h2 class="title" v-if="item.headline" v-html="item.headline"></h2>
            <p class="text" v-if="item.text" v-html="item.text"></p>
          </div>
          <div class="col-12 col-md-6 text-center order-0" :class="item.side === 'left' ? 'order-md-1' : 'order-md-0'">
            <parallax ref="parallax" :from="{ y: 100 }" :to="{ y: -100 }">
              <div slot-scope="{ parallax }" :style="`transform: translate3d(0px, ${ (parallax && parallax.y) ? Math.round(parallax.y) : 0 }px, 0px)`">
                <lazy-picture :item="item" preserve-ratio="true"></lazy-picture>
              </div>
            </parallax>
          </div>
        </div>
      </div>
    </Observer>
    <button type="button" class="btn-scroll" @click="scrollDown" :aria-label="$t('Scroll down')">
      <i class="icon-back-copy"></i>
    </button>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import { Parallax } from 'leaps/dist/leaps'
import LazyPicture from './utils/LazyPicture'
// import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  name: 'TimelineDecade',
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  components: {
    LazyPicture,
    Parallax
  },
  mixins: [ReadyHook],
  data () {
    return { }
  },
  methods: {
    enter () {
      this.$refs.parallax.updateConfig()
      this.$refs.parallax.update()
    },
    scrollDown () {
      if (window) {
        window.scrollTo({
          top: this.$el.offsetHeight + this.$el.offsetTop,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/core';

section {
  position: relative;
  padding: 14rem 0;

  @include bp(max md) {
    padding: 4rem 0 13rem;
  }

  &.-watermark {
    background: url('/assets/img/watermark.png') no-repeat center;

    @include bp(max md) {
      background: url('/assets/img/watermark.png') top no-repeat / 250%;
    }
  }

  &.bg {
    &-light {
      background-color: var(--zenith-white);

      .date span {
        color: var(--zenith-white);
      }
    }

    &-dark {
      background-color: var(--zenith-grey-light);

      .date span {
        color: var(--zenith-grey-light);
      }
    }
  }

  /deep/ img {
    max-width: 90%;
    @include bp(max md) {
      margin-bottom: 2rem;
    }
  }

  .date {
    display: block;
    margin-bottom: 1.6rem;
    font-weight: 500;
    font-size: em(184);
    line-height: em(184, 184);
    color: var(--zenith-theme-primary-lighter);

    @include bp(max md) {
      font-size: em(116);
      line-height: em(100, 116);
      text-align: center;
      display: block;
    }

    span {
      text-shadow: 1px 0 0 var(--zenith-theme-primary), 0 1px 0 var(--zenith-theme-primary), 0 -1px 0 var(--zenith-theme-primary), -1px 0 0 var(--zenith-theme-primary), 1px 1px 0 var(--zenith-theme-primary), 1px -1px 0 var(--zenith-theme-primary), -1px 1px 0 var(--zenith-theme-primary), -1px -1px 0 var(--zenith-theme-primary);
    }
  }

  .title {
    color: var(--zenith-theme-primary-lighter);
    margin-bottom: 1.6rem;
    margin-left: 18rem;

    @include bp(max md) {
      margin-left: 0;
      display: block;
      text-align: center;
    }
  }

  .text {
    color: var(--zenith-grey);
    margin-bottom: 0;
    padding: 0;
    margin-left: 18rem;

    @include bp(max md) {
      margin-left: 0;
      display: block;
      text-align: center;
    }
  }

  button.btn-scroll {
    position: absolute;
    z-index: 20;
    left: 50%;
    bottom: 8rem;
    width: 4.8rem;
    color: var(--zenith-theme-primary);
    padding: 1.3rem 0;
    border-radius: 100%;
    border: 1px solid var(--zenith-border);
    background: transparent;
    transform: translateX(-50%);

    @include bp(max md) {
      bottom: 4rem;
    }

    i {
      display: block;
      font-size: em(20);
      line-height: 2rem;
      animation: bouncing 1s infinite ease-in-out;
    }

    &:hover, &:active, &:focus {
      background: var(--zenith-theme-primary);
      color: var(--zenith-white);
    }
  }
}

@keyframes bouncing {
  0%, 100% {
    transform: translateY(-.3rem);
  }
  25% {
    transform: translateY(.7rem);
  }
}

@include bp(max md) {
  /deep/ .obs {
    .col-12 > div {
      transform: none !important;
    }
  }
}

</style>
